<template>
	<loading v-bind:loading="loading" />
	<div class="overflow-y-auto px-10">
		<div v-if="!loading && debtorCases.length > 0" class="my-10 text-left">
			<div class="grid w-full sm:grid-cols-3 sm:gap-10 mb-10 text-md">
				<div class="flex flex-col">
					<span class="text-md pt-3 ml-1"
						>Nº de elementos en la página</span
					>
					<select
						@change="filterDebts()"
						v-model="itemsPerPage"
						name="filterCount"
						id="select-filter-count"
						class="boder border-black w-full mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3 pt-2 pb-3"
					>
						<option value="0" disabled>Seleccione</option>
						<option value="10">10</option>
						<option value="20">20</option>
						<option value="30">30</option>
						<option value="50">50</option>
					</select>
				</div>
				<div class="flex flex-col">
					<span class="pt-3 ml-1">Ordenar por el campo</span>
					<select
						@change="filterDebts()"
						v-model="sortField"
						name="filterCount"
						id="select-filter-count"
						class="boder border-black w-full mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3 pt-2 pb-3"
					>
						<option value="0" disabled>Seleccione</option>
						<option value="ClientReference">Factura</option>
						<option value="MainParticipant">Titular</option>
						<option value="OriginalAmount">Total deuda</option>
						<option value="DebitBalance">Por reclamar</option>
						<option value="ImportDate">Reclamación</option>
						<option value="Status">Estado</option>
					</select>
				</div>
				<div class="flex flex-col">
					<span class="text-md pt-3 ml-1">Ordenar asc/desc</span>
					<select
						@change="filterDebts()"
						v-model="sortType"
						name="filterCount"
						id="select-filter-count"
						class="boder border-black w-full mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3 pt-2 pb-3"
					>
						<option value="0" disabled>Seleccione</option>
						<option value="asc">De menor a mayor</option>
						<option value="desc">De mayor a menor</option>
					</select>
				</div>
			</div>

			<sirit-table
				@getNextPage="getNextPage"
				@getPreviousPage="getPreviousPage"
				:headers="headers"
				:items="debtorCases"
				:loading="loading"
				:loadingPage="loading"
				pagination
				:page="page"
				:itemsPerPage="itemsPerPage"
				:maxPages="totalPages"
			>
				<template v-slot="props">
					<td class="pb-3 pt-3 px-2">
						{{ props.item.clientReference }}
					</td>
					<td class="pb-3 pt-3 px-2">
						{{ props.item.mainParticipant }}
					</td>
					<td class="pb-3 pt-3 px-2 text-right">
						{{ global.formatAmount(props.item.originalAmount) }}
					</td>
					<td class="pb-3 pt-3 px-2 text-right">
						{{ global.formatAmount(props.item.debitBalance) }}
					</td>
					<td class="pb-3 pt-3 px-2 text-center">
						{{
							global.getFormatDateComplete(
								props.item.importDate,
								3
							)
						}}
					</td>
					<td class="pb-3 pt-3 px-2">{{ props.item.status }}</td>
					<td class="pb-3 pt-3 px-2">
						<button
							@click="
								eventOpenModal_(
									props.item.id,
									props.item.lastUpdateDate,
									props.item.debitBalance
								)
							"
							:class="`text-${colors.primary}-500 border-${colors.primary}-500 hover:bg-${colors.primary}-600`"
							class="w-full text-md p-1 rounded-md border-2 hover:text-white hover:border-white"
						>
							Comunicar cobro
						</button>
					</td>
					<td
						class="pb-3 pt-3 px-2"
						:class="[type !== '' ? 'text-center' : '']"
					>
						<span
							@click="eventOpenModal_comment(props.item)"
							class="cursor-pointer mx-1 text-black"
						>
							<fa icon="envelope" />
						</span>
					</td>
					<td
						class="pb-3 pt-3 px-2"
						:class="[type !== '' ? 'text-center' : '']"
					>
						<span
							@click="detail(props.item.id)"
							class="cursor-pointer mx-1 text-black"
						>
							<span class="hidden xl:inline">
								Ver detalle
							</span>	
							<fa icon="angle-right"/>						
						</span>
					</td>
				</template>
			</sirit-table>
		</div>

		<div v-else-if="!loading && debtorCases.length == 0" class="mt-5 sm:mt-8 xl:mt-20 lg:mt-40">
			<div
				class="w-full grid mb-20 text-center"
				v-if="idClient === global.getClietIdSession()"
			>
				<div class="w-full flex pt-8 mb-8">
					<img
						alt="logo"
						src="../../assets/TRECUPERA_imagen_felicidades_CYAN.png"
						class="w-40 h-40 mx-auto"
					/>
				</div>
				<div class="w-full mb-3 font-bold text-sirit_blue-500">
					¡Felicidades! ya estamos listos para comenzar
				</div>
				<div class="w-full">
					<div class="font-bold mb-3">
						Aún no tienes ninguna reclamación subida
					</div>
					<div>Aprovecha y sube tu primera factura ahora mismo</div>
				</div>
			</div>
			<div v-else>No hay registros disponibles</div>
		</div>
	</div>
	<comunication-modal
		@onFireDebts="getDebts()"
		@onFire="eventOpenModal_"
		:openModal="openModal"
		v-bind:debtorCaseId="debtorCaseId"
		v-bind:lastUpdateDate="lastUpdateDate"
		v-bind:amount="amount"
	/>
	<comment-modal
		v-if="openModalComment"
		@onFire="eventOpenModal_comment"
		:openModal="openModalComment"
		:item="itemDeptorcase"
	/>
</template>

<script lang="ts">
	import axios from "axios";
	import { reactive, toRefs } from "vue";
	import { useRouter } from "vue-router";
	import ComunicationModal from "@/components/Debt/ComunicationModal.vue";
	import CommentModal from "@/components/Debt/CommentModal.vue";
	import * as global from "@/api/global";
	import Loading from "@/components/Commons/Loading.vue";
	import SiritTable from "@/components/Commons/SiritTable.vue";

	export default {
		name: "ClientsList",
		components: { ComunicationModal, CommentModal, Loading, SiritTable },
		props: {
			idClient: { type: Number, required: true, default: 0 },
			type: { type: String, required: true, default: "" },
		},
		emits: ["onFire"],
		setup(props: any, { emit }: any) {
			const state = global.state;
			const { colors } = state.configTenant.template;

			interface debtorCase {
				debtorCases: Array<any>;
				openModal: Boolean;
				openModalActivity: Boolean;
				openModalComment: Boolean;
				debtorCaseId: number;
				lastUpdateDate: String;
				amount: number;
				loading: Boolean;
				itemDeptorcase: Object;
				page: number;
				firstLoadingIsComplete: boolean;
				headers: Array<any>;
				itemsPerPage: number;
				totalItems: number;
				totalPages: number;
				sortField: String;
				sortType: String;
			}

			let data = reactive<debtorCase>({
				debtorCases: [],
				openModal: false,
				openModalActivity: false,
				openModalComment: false,
				debtorCaseId: 0,
				lastUpdateDate: "",
				amount: 0,
				loading: false,
				itemDeptorcase: {},
				page: 0,
				firstLoadingIsComplete: false,
				headers: [
					{ label: "Factura", align: "left" },
					{ label: "Titular", align: "left" },
					{ label: "Total deuda", align: "right" },
					{ label: "Por reclamar", align: "right" },
					{ label: "Reclamación", align: "center" },
					{ label: "Estado", align: "left" },
					{ label: "Acciones", align: "left" },
					{ label: "", align: "left" },
				],
				itemsPerPage: 30,
				totalItems: 0,
				totalPages: 0,
				sortField: "ClientReference",
				sortType: "asc",
			});

			let errors = reactive([
				{
					code: 16691464,
					msg: "1",
				},
			]);

			const eventOpenModal_ = (
				id: number,
				lastDate: string,
				amount: number
			) => {
				data.openModal = !data.openModal;
				data.debtorCaseId = id;
				data.lastUpdateDate = global.getFormatDateComplete(lastDate, 4);
				data.amount = amount;
			};

			const eventOpenModal_activity = (item: Object) => {
				data.openModalActivity = !data.openModalActivity;

				setDeptorCase(item);
			};

			const eventOpenModal_comment = (item: Object) => {
				data.openModalComment = !data.openModalComment;

				setDeptorCase(item);
			};

			const setDeptorCase = (item: Object) => {
				data.itemDeptorcase = item;
			};

			const getDebts = async () => {
				data.loading = true;
				const url =
					process.env.VUE_APP_BASE_URL +
					`/Client/${props.idClient}/debtorcases?PageIndex=${
						data.page + 1
					}&PageSize=${data.itemsPerPage}&SortField=${
						data.sortField
					}&SortType=${data.sortType}`;
				let response = null;
				try {
					response = await axios.get(url, {
						headers: {
							Authorization: `Bearer ${global.getToken()}`,
						},
					});
				} catch (e: any) {
					response = e.response;
				}

				if (response.status == 200) {
					data.debtorCases = response.data.items;
					data.totalItems = response.data.totalCount;
					data.totalPages = Math.ceil(
						data.totalItems / data.itemsPerPage
					);
					setCountDeptorCases();
				} else {
					errors = response.data;
					if (response.status == 401) {
						global.logout();
					}
				}
				data.loading = false;
			};

			const router = useRouter();

			const detail = (id: number) => {
				router.push({ name: "DebtDetail", params: { id } });
			};

			const setCountDeptorCases = () => {
				emit("onFire", data.debtorCases.length);
			};

			function getNextPage() {
				data.page += 1;
				getDebts();
			}

			function getPreviousPage() {
				data.page -= 1;
				getDebts();
			}

			function filterDebts() {
				data.page = 0;
				data.totalItems = 0;
				data.totalPages = 0;
				getDebts();
			}

			if (!global.isSessionExpired()) {
				getDebts();
			}

			return {
				global,
				colors,
				eventOpenModal_,
				eventOpenModal_activity,
				eventOpenModal_comment,
				errors,
				getDebts,
				setDeptorCase,
				detail,
				setCountDeptorCases,
				getNextPage,
				getPreviousPage,
				filterDebts,
				...toRefs(data),
			};
		},
	};
</script>
